import { useState } from "react";
import styled from "styled-components";
import MonthShiftGrid from "./MonthShiftGrid";

export default function Shifts() {
    const [view, setView] = useState<'seller' | 'admin'>('seller')

    return (
        <Main>
            <div className="toggle">
                <button
                    type="button"
                    className={view === 'seller' ? 'active' : ''}
                    onClick={() => setView('seller')}
                >
                    Vendedores en agencia
                </button>
                <button
                    type="button"
                    className={view === 'admin' ? 'active' : ''}
                    onClick={() => setView('admin')}
                >
                    Administradores
                </button>
            </div>
            <MonthShiftGrid role={view} />
        </Main>
    )
}

const Main = styled.div`
.toggle {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: 20px 0;
    button {
        padding: 10px 20px;
        border-radius: 8px;
        border: 2px solid ${props => props.theme.blue};
        background: transparent;
        color: ${props => props.theme.blue};
        cursor: pointer;
        font-weight: 600;
    }
    button.active {
        background-color: ${props => props.theme.blue};
        color: ${props => props.theme.white};
    }
}
`
